<template>
    <div class="main-box">
        <base-header :head_id="user_info.avtar_head" :name="user_info.name" :lv="user_info.level" 
            ref= "switchRef" :account_list="account_list"></base-header>
        <base-rules ref= "rulesRef"></base-rules>
        <base-agree ref= "agreeRef"></base-agree>
        <div class="account">
            <ul class="account-ul">
                <li class="account-li">
                    <img :src="require(`@/assets/img/level/LV${user_info.vip_1_level?user_info.vip_1_level:0}.png`)" alt />
                    <div class="num">{{user_info && user_info.vip_1_level!=undefined? `V${user_info.vip_1_level}` : ''}}</div>
                    <div class="divider"></div>
                </li>
                <li class="account-li">
                    <img src="@/assets/img/jiubi.png" alt />
                    <div class="num">{{user_info.money1}}</div>
                    <div class="divider"></div>
                </li>
                <li class="account-li">
                    <img src="@/assets/img/jiudou.png" alt />
                    <div class="num">{{user_info.money2}}</div>
                    <div class="divider"></div>
                </li>
                <li class="account-li">
                    <base-button :name="`充值`" :wd="`1rem`" :ht="`.56rem`" :br="`.28rem`" :fz="`.26rem`" :cl="`#ffebc6`" @click="showPayPop"></base-button>
                </li>
            </ul>
        </div>
        <div class="menu">
            <ul class="menu-ul">
                <li class="menu-li" @click="isActive = !isActive">
                    <img :src="square_icon" alt />
                    <div class="name">账号信息</div>
                    <div class="down">
                        <i :class="isActive?'el-icon-arrow-up':'el-icon-arrow-down'"></i>
                    </div>
                    <collapse>
                        <div class="container" v-show="isActive">
                            <p>手机号：{{replacePhoneToStar(user_info.moile)}}</p>
                            <p>辅助邮箱：{{user_info.email?replaceEmailToStar(user_info.email):'-'}}</p>
                            <p>实名信息：{{user_info.real_name? `${user_info.real_name}（${user_info.id_card_number}）` : '-'}}</p>
                        </div>
                    </collapse>
                </li>
                <li class="menu-li" v-for="(item, index) in menu_list" :key="index">
                    <img :src="square_icon" alt />
                    <!-- <img :src="require(`@/assets/img/home/LV${index}.png`)" alt="" /> -->
                    <div class="name" @click="jump_to(item.path)">{{item.name}}</div>
                </li>
            </ul>
        </div>
        <!-- 充值 -->
        <el-dialog title :visible.sync="pop_pay" class="pay-pop" v-if="pop_pay" :close-on-click-modal="false">
            <div class="close" @click="closePop()"></div>
            <div class="title">充值酒币</div>
            <base-divider></base-divider>
            <ul class="money-ul">
                <li :class="`money-li ${pay_money == item ? 'choosed': ''}`" v-for="(item, index) in money_list" :key="index" 
                        @click="choose_money(item, index)">
                    <div class="num">{{item}}元</div>
                </li>
            </ul>
            <base-input :title="`其他金额：`" v-model="pay_input" :type="`number`"
                @blur="check_money()" :placeholder="`10 - 3000区间`" class="pay-input" :cl="`#2E2E2E`" :suffix="`元`"></base-input>
            <div class="info">
                本次充值可获得：
                <span>{{Number(pay_money * 10)}}</span>酒币
            </div>
            <base-divider></base-divider>
            <div class="pay-bottom">
                <p>
                    应付：
                    <span>{{pay_money}}</span>元
                </p>
                <base-button :name="`立即支付`" class="pay-btn" :wd="`2.54rem`" :ht="`1rem`" @click="buy"></base-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { baseUrls } from '@/utils/baseUrlConfig'
const base_url = baseUrls.user_url
import { replacePhoneToStar, replaceEmailToStar } from '@/utils/common'

export default {
    name: 'index',
    data() {
        return {
            token: this.$storage.getToken(),
            pay_input: '',
            square_icon: require('@/assets/img/square.png'),
            menu_list: [
                { name: '充值/消费记录', path: '/pay_record' },
                { name: '发票中心', path: '/invoice_log' },
                { name: '联系客服', path: '/contact' },
                { name: '用户条例', path: '/user_rules' },
                { name: '使用协议', path: '/user_agreement' },
            ],
            isActive: false,
            pop_pay: false,
            user_info: {},
            account_list: [],
            money_list: [10, 50, 100, 500],
            pay_money: 10,
            payData: {},
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            if (from.path != "/pay_record" && from.path != "/contact"
                && from.path != "/success_pay" && from.path != "/invoice"
                && from.path != "/invoice_log"  && vm.$common.checkToken(vm.token)){
                vm.$http.set_anchor(1, vm.token)
                // console.log('写入锚点=====个人中心');
            }
        });
    },
    created() {
        this.requireToken()
    },
    methods: {
        requireToken() {
            var Ucookie = this.token;
            if (Ucookie != null) {
                var now = new Date().getTime();
                if (now >= Ucookie.split('-')[3] * 1000) { //token过期
                    this.get_auth();
                } else {
                    this.init();
                }
            } else{
                this.get_auth();
            }
        },
        check_money(){
            this.pay_money =  this.pay_input;
        },
        choose_money(item){
            this.pay_money = item;
        },
        jump_to(path){
            if(path == '/invoice1'){
                this.$alert('请登录平台官网进行开票', '', {
                    customClass: 'message-logout',
                    showClose: false,
                    type: 'info',
                    confirmButtonText: '确定',
                    callback: action => {
                    }
                });
                // this.$message.info('请登录平台官网进行开票');
            }else if(path == '/user_rules'){
                this.$refs.rulesRef.openPop();
            }else if(path == '/user_agreement'){
                this.$refs.agreeRef.openPop();
            }else{
                this.$router.push(path)
            }
        },
        replacePhoneToStar(number){
            return replacePhoneToStar(number)
        },
        replaceEmailToStar(number){
            return replaceEmailToStar(number)
        },
        get_auth() {
            window.location.replace(base_url + '/GetWxOpenid')
        },
        init() {
            this.token = this.$storage.getToken();
            this.$http.getUserInfo(this.token).then((res) => {
                if (res.result == 0 && res.temp) {
                    this.user_info = Object.assign({}, this.user_info, res.temp)
                    this.$storage.setUserId(this.user_info.user_id)
                    this.$storage.setUserName(this.user_info.name)
                    this.$storage.setHeadId(this.user_info.avtar_head)
                    this.$storage.setUserLevel(this.user_info.level)
                    this.$storage.setUserFlag(this.user_info.flag)
                }
            })
            this.$http.getUserAchievementDetails(this.token).then((res) => {
                if (res.result == 0 && res.temp) {
                    this.user_info = Object.assign({}, this.user_info, res.temp)
                }
            })
            this.$http.q_my_money(this.token).then((res) => {
                if (res.code == 0 && res.records && res.records.length > 0) {
                    let msg = res.records[0]
                    this.user_info = Object.assign({}, this.user_info, msg)
                }
            })
            this.$http.getAllUser(this.token).then((res) => {
                if (res.result == 0 && res.msg && res.msg.length > 0) {
                    this.account_list = res.msg
                    this.$storage.setAccountList(JSON.stringify(res.msg));
                } else {
                    this.account_list = []
                }
            })
        },
        // 切换账号
        switch_account_new(user_id){
            if(this.token.split('-')[0] == user_id){
                this.$message.error('不能切换至当前账号')
                return false
            }
             this.$http.setLoginByWx(this.token, user_id, this.$storage.getOpenId()).then((res) => {
                if (res.code == 0){
                    this.$message.success('切换成功')
                    this.$refs.switchRef.closePop();
                    this.token = res.token;
                    this.init();
                } else{
                    this.$message.error(res.err?res.err:'切换失败');
                }
            })
        },
        showPayPop(val) {
            this.pop_pay = true
        },
        closePop() {
            this.pop_pay = false
        },
        buy() {
            if(Number(this.pay_money) > 3000){
                this.$message.error('充值金额最大为3000元');
                return false 
            } else if(Number(this.pay_money) < 10){
                this.$message.error('充值金额最小为10元');
                return false 
            }

            let self = this;
            if (this.btn_lock) { return false }
            this.btn_lock = true;
            this.$http.q_hd('PubPay', 'https://wx.pay.09game.com/WeChatPay/',  {
                token: this.token,
                total_fee: Number(this.pay_money*10)
            }, true).then((res) => {
                this.btn_lock = false;
                if (res.code == 1) {
                    alert(res.msg);
                } else if (res.code == 0) {
                    console.log(res.data);
                    self.payData = res.data;
                    if (typeof WeixinJSBridge == "undefined") {
                        if (document.addEventListener) {
                            document.addEventListener('WeixinJSBridgeReady', self.onBridgeReady, false);
                        } else if (document.attachEvent) {
                            document.attachEvent('WeixinJSBridgeReady', self.onBridgeReady);
                            document.attachEvent('onWeixinJSBridgeReady', self.onBridgeReady);
                        }
                    } else {
                        self.onBridgeReady();
                    }
                }
            })
        },

        onBridgeReady() {
            let self = this;
            window.WeixinJSBridge.invoke(
                'getBrandWCPayRequest', {
                "appId": this.payData.appId, //公众号名称，由商户传入 ok
                "timeStamp": this.payData.timeStamp, //时间戳，自1970年以来的秒数 ok
                "nonceStr": this.payData.nonceStr, //随机串
                "package": this.payData.package,
                "signType": "MD5", //微信签名方式
                "paySign": this.payData.paySign //微信签名
            },
            function (res) {
                if (res.err_msg == "get_brand_wcpay_request:ok") {
                    // 使用以上方式判断前端返回,微信团队郑重提示：
                    //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                    self.$router.push('/success_pay');
                } else {
                    if (res.err_msg == 'get_brand_wcpay_request:cancel') {
                        alert('取消支付！');
                    } else if (res.err_msg == 'get_brand_wcpay_request:fail') {
                        alert('支付失败！');
                    } else {
                        alert(res.err_msg);
                    }
                }
            });
        },
    },
}
</script>
<style lang="scss">
.message-logout{
    width: 75%!important;
}
.pay-pop {
    .el-dialog {
        width: 100%;
        padding: 0;
        margin: 0;
        margin-top: 0 !important;
        background: transparent !important;
        border-radius: 0;
        box-shadow: none !important;
        -webkit-box-shadow: none !important;

        .el-form {
            padding-right: 80px;
        }

        .el-dialog__header {
            padding: 0;
            margin: 0;
            // display: none;
            .el-dialog__title {
                font-size: 16px;
            }
            .el-dialog__headerbtn .el-dialog__close {
                font-size: 16px !important;
            }
        }
        .el-dialog__body {
            padding: 0;
            margin: 0;
            box-shadow: none;
            -webkit-box-shadow: none;
        }

        .el-dialog__footer {
            padding: 0;
            margin: 0;
        }
    }
}
</style>
<style lang="scss" scoped>
.main-box {
    .account {
        width: 92%;
        height: 1.1rem;
        background: #ffffff;
        margin: 0 auto;
        margin-top: 0.26rem;
        border-radius: 0.2rem;
        .account-ul {
            width: 100%;
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: nowrap;
            .account-li {
                width: 25%;
                height: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-wrap: wrap;
                align-content: center;
                position: relative;
                img {
                    width: 0.34rem;
                    height: 0.34rem;
                    margin: 0.1rem 0 0 0;
                }
                .num {
                    width: 100%;
                    color: #1a1a1a;
                    font-size: 0.26rem;
                    // font-weight: bold;
                    height: 0.46rem;
                    line-height: 0.46rem;
                    text-align: center;
                }
                .divider {
                    width: 0.02rem;
                    height: 1.88rem;
                    background: #f0f1f5;
                    position: absolute;
                    top: 0.08rem;
                    right: 0;
                    transform: scale(0.5);
                    transform-origin: left top;
                }
            }
        }
    }

    .menu {
        width: 92%;
        height: auto;
        background: #ffffff;
        margin: 0 auto;
        margin-top: 0.2rem;
        border-radius: 0.2rem;
        .menu-ul {
            width: 93%;
            height: auto;
            margin: 0 auto;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            .menu-li {
                width: 100%;
                min-height: 1.1rem;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-wrap: wrap;
                align-content: center;
                position: relative;
                // border-bottom: .01rem solid #DDDDDD;

                &:after {
                    content: '';
                    height: 0.02rem;
                    background: #dddddd;
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    width: 200%;
                    transform: scale(0.5);
                    transform-origin: left top;
                }
                &:last-of-type:after {
                    content: '';
                    display: none !important;
                }
                img {
                    width: 0.12rem;
                    height: 0.12rem;
                    position: absolute;
                    top: 0.5rem;
                    left: 0.1rem;
                }
                .container {
                    width: 100%;
                    padding-left: 0.5rem;
                    p {
                        color: #939393;
                        font-size: 0.26rem;
                        height: 0.44rem;
                        line-height: 0.44rem;
                        text-align: left;
                        width: 100%;
                        &:last-child {
                            height: 0.6rem;
                            line-height: 0.44rem;
                        }
                    }
                }
                .name {
                    width: 100%;
                    color: #2e2e2e;
                    padding-left: 0.4rem;
                    font-size: 0.32rem;
                    height: 1.1rem;
                    line-height: 1.1rem;
                    text-align: left;
                    font-weight: normal;
                }
                .down {
                    position: absolute;
                    top: 0.3rem;
                    right: 0.3rem;
                }
            }
        }
    }

    .pay-pop {
        width: 6.24rem;
        height: 8.34rem;
        background: #ffffff;
        border-radius: 0.3rem;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        .close {
            position: absolute;
            top: 0.2rem;
            right: 0.2rem;
            width: 0.56rem;
            height: 0.56rem;
            background: url(~@/assets/img/close.png) 0 0 no-repeat;
            background-size: 100% auto;
            &:hover {
                cursor: pointer;
                background-position-y: -0.56rem;
            }
        }
        .title {
            width: 100%;
            font-size: 0.4rem;
            text-align: center;
            height: 1.2rem;
            font-weight: bold;
            line-height: 1.25rem;
            color: #c39b5e;
        }
        .money-ul {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            width: 100%;
            margin-top: 0.3rem;
            .money-li {
                list-style: none;
                width: 2.34rem;
                height: 1.06rem;
                background: #ffffff;
                border: 0.01rem solid #dddddd;
                border-radius: 0.04rem;
                margin: 0.21rem;

                .num {
                    width: 100%;
                    height: 1.06rem;
                    line-height: 1.06rem;
                    text-align: center;
                    color: #2e2e2e;
                    font-size: 0.34rem;
                    font-weight: bold;
                }
                &:hover,
                &.choosed {
                    background: #c39b5e;
                    border: 1px solid #c39b5e;
                    .num {
                        color: #ffffff;
                    }
                }
            }
        }

        .pay-input {
            width: 5.1rem;
            height: 1.1rem;
            line-height: 1.1rem;
            border-color: #dddddd;
            margin: 0.1rem auto 0.33rem auto;
        }

        .info {
            width: 100%;
            text-align: center;
            color: #2e2e2e;
            font-size: 0.28rem;
            height: 0.35rem;
            line-height: 0.35rem;
            margin-bottom: 0.33rem;
            span {
                color: #c39b5e;
                font-size: 0.4rem;
                font-weight: bold;
                padding-right: 0.05rem;
                vertical-align: top;
            }
        }
        .pay-bottom {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 0.3rem;
            margin-top: 0.33rem;
            p {
                text-align: center;
                color: #2e2e2e;
                font-size: 0.28rem;
                height: 0.5rem;
                line-height: 0.5rem;
                span {
                    color: #c39b5e;
                    font-size: 0.6rem;
                    line-height: 0.5rem;
                    font-weight: bold;
                    padding-right: 0.1rem;
                    vertical-align: bottom;
                }
            }
            .pay-btn {
                margin: 0;
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/view/index.vue